import { AfterViewInit, Component, computed, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { basicCiInterface, ciInterface, ciInterface2 } from 'src/app/util/interfaces/ci';
import { ciTypesInterface } from 'src/app/util/interfaces/ciTypes';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { CmdbRegisterPageService } from './service/cmdb-register-page.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import {
	faCheckSquare,
	faSquare,
	faAngleLeft,
	faAngleRight,
	faDownload,
	faExclamationCircle,
	faFileUpload,
	faInfo,
	faLink,
	faNetworkWired,
	faQrcode,
	faQuestionCircle,
	faSearch,
	faTimes,
	faTrash,
	faUpload,
	faXmark,
	faAngleUp,
	faAngleDown,
	faSortDown,
	faSortUp,
	faMagnifyingGlassPlus,
	faMagnifyingGlassMinus,
	faArrowsToDot,
} from '@fortawesome/free-solid-svg-icons';
import { PermissionService } from 'src/app/util/services/permission/permission.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { mspFileInterface } from 'src/app/util/interfaces/mspFile';
import { FilesService } from 'src/app/services/files/files.service';
import { GenericFormGenService } from 'src/app/page_component_item/generic-form-gen/service/generic-form-gen.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { firstValueFrom, Subscription, zip } from 'rxjs';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { CmdbInfoPageService } from '../cmdb-info-page/service/cmdb-info-page.service';
import { logInterface } from 'src/app/util/interfaces/log.interface';
import { DateService } from 'src/app/services/date/date.service';
import { TreeNode } from 'primeng/api';
import { ShkDate } from 'shk-date';
import { LoadingNotificationService } from 'src/app/services/loading-notification/loading-notification.service';
import { CmdbDigitalTerm } from 'src/app/util/interfaces/cmdbDigitalTerm';
import { CmdbHomeScreenService } from '../cmdb-home-screen/service/cmdb-home-screen.service';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { CmdbPermissions } from 'src/app/util/interfaces/cmdbPermissions';
import { CmdbPermissionsService } from '../cmdb-permissions/service/cmdb-permissions.service';
import { ModalComponent } from 'src/app/page_component_item/modal/modal.component';
import { InconsistenciesComponent } from '../../my-asset/inconsistencies/inconsistencies.component';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { allowedCMDBRegisterPageTabViews, CMDBRegisterPageTabView } from './data/cmdb-register-page.model';
import { CmdbRegisterPageInfoComponent } from './components/cmdb-register-page-info/cmdb-register-page-info.component';
@Component({
	selector: 'app-cmdb-register-page',
	templateUrl: './cmdb-register-page.component.html',
	styleUrls: ['./cmdb-register-page.component.scss', '../../../../styles/tabs.styles.scss'],
})
export class CmdbRegisterPageComponent implements OnInit {
	icons = {
		faInfo: faInfo,
		faNetworkWired: faNetworkWired,
		faFileUpload: faFileUpload,
		faTrash: faTrash,
		faTimes: faTimes,
		faDownload: faDownload,
		faCheckSquare: faCheckSquare,
		faSquare: faSquare,
		faQrcode: faQrcode,
		faExclamationCircle: faExclamationCircle,
		faXmark: faXmark,
		faAngleUp: faAngleUp,
		faAngleDown: faAngleDown,
		faAngleLeft: faAngleLeft,
		faAngleRight: faAngleRight,
		faSortDown: faSortDown,
		faSortUp: faSortUp,
		faMagnifyingGlassPlus: faMagnifyingGlassPlus,
		faMagnifyingGlassMinus: faMagnifyingGlassMinus,
		faArrowsToDot: faArrowsToDot,
	};

	labels: LabelsInterface;

	constructor(
		private LabelsService: LabelsService,
		private Router: Router,
		private ActivatedRoute: ActivatedRoute,
		private CmdbRegisterPageService: CmdbRegisterPageService,
		private CmdbInfoPageService: CmdbInfoPageService,
		private GenericFormGenService: GenericFormGenService,
		private NotificationService: NotificationService,
		private ProfileService: ProfileService,
		private FilesService: FilesService,
		private LoadingNotificationService: LoadingNotificationService,
		public PermissionService: PermissionService,
		public DateService: DateService,
		public CmdbHomeScreenService: CmdbHomeScreenService,
		public CmdbPermissionsService: CmdbPermissionsService
	) {
		this.labels = computed(() => this.LabelsService.labels())();
	}

	@ViewChild('digitalTermModal') digitalTermModal: ModalComponent;
	@ViewChild('bondCiModal') bondCiModal: ModalComponent;
	@ViewChild(CmdbRegisterPageInfoComponent) cmdbRegisterPageInfoComponent: CmdbRegisterPageInfoComponent;

	isLoadingCiBasicInformation = true;
	isLoadingImpactMap = true;
	isUpdatingDigitalTerm = false;
	isLoadingChangeTab = false;
	isUserNotified = false;

	ciLogReq: Subscription;
	ciTermLogReq: Subscription;

	existingInAd = false;

	tabView: CMDBRegisterPageTabView = 'info';

	todayDate = new ShkDate();
	baselineDate = new ShkDate();

	ciList: basicCiInterface[] = [];
	selectedCi: ciInterface2;

	viewType: 'read' | 'edit';
	lockViewType = false;
	formColumns = 2;
	cmdbListQueryParams: Params = {};
	cameFromCmdbList = false;
	private readonly cmdbListFiltersStorageKey = 'cmdbListFilters';

	searchCi: ciInterface = {
		ciType: '',
		ciIcon: '',
		ciArray: [
			{
				identification: '',
				notes: '',
				status: '',
				enduser: '',
				purchase_order: '',
				purchase_date: null,
				physical_location: '',
				type: '',
				id: '',
				cmdb_id: '',
			},
		],
	};

	modalIdStockCmdb = '';

	// Impact Map
	isImpactMapOpen = false;

	isLoadingImpactMapCiParents = false;
	isLoadingImpactMapCiChildrens = false;
	isLoadingFirstTreeDownLevel = false;

	selectedNode: TreeNode<ciInterface2>;
	impactMapData: TreeNode<ciInterface2>[] = [];

	impactMapPos = {
		sX: 0,
		sY: 0,
		x: 0,
		y: 0,
		zoomLevel: 1,
		mouseDown: false,
		mouseMove: false,
	};

	canEditSelectedCi = true;
	impactMapView = 'cmdb';

	cmdbDigitalTermForm: genericFormI[] = [];
	cmdbDigitalTermPayload: CmdbDigitalTerm = {} as CmdbDigitalTerm;
	cmdbDigitalTermPayloadCopy: CmdbDigitalTerm | null = null;
	cmdbDigitalTermLogPayload: CmdbDigitalTerm[] = [];
	baselineToDigitalTermPayload: any = {} as any;

	isVisible = false;
	isEditingTerm = true;
	isLoadingLogTerm = false;

	allowedUserCopy: any[] = [];
	allowedUserCopyIAC: iacOptionInterface[] = [];
	selectedUserCopyUser: any = { full_name: '', email: '', id: '' };
	isLoadingUserCopy = false;

	ngOnInit(): void {
		this.cmdbListQueryParams = this.ActivatedRoute.snapshot.queryParams;
		if (Object.keys(this.cmdbListQueryParams).length === 0) {
			this.cmdbListQueryParams = this.getCmdbListFiltersFromStorage();
		}
		this.cameFromCmdbList = Boolean(this.ActivatedRoute.snapshot.params['idCi']);

		this.ActivatedRoute.url.subscribe({
			next: (url) => {
				if (url[1].path == 'new' || url[2].path == 'edit') {
					this.viewType = 'edit';
				} else if (url[2].path == 'read') {
					this.viewType = 'read';
				}
			},
		});

		this.ActivatedRoute.params.subscribe({
			next: (parameter) => {
				if (parameter.tabView && allowedCMDBRegisterPageTabViews.includes(parameter.tabView as CMDBRegisterPageTabView)) {
					this.changeTab(parameter.tabView as CMDBRegisterPageTabView, parameter.idCi);
				} else {
					this.changeTab('info', parameter.idCi);
				}

				if (parameter.idCi) {
					const idCiArray = parameter.idCi.split(',');
					this.CmdbRegisterPageService.getBasicCiInformation(parameter.idCi)
						.subscribe({
							next: (ciListRes) => {
								this.ciList = ciListRes;
								const firstCiOnUrl = this.ciList.find((ci) => ci.id.toString() === idCiArray[0].toString());
								this.checkCiInViewPermissions(firstCiOnUrl);
							},
						})
						.add(() => {
							this.isLoadingCiBasicInformation = false;
						});
					this.getCiData(idCiArray[0]);
				} else {
					this.cleanSelectedCi();
					this.isLoadingCiBasicInformation = false;
				}
			},
		});

		this.getSendEmailCopy();
	}

	private getCmdbListFiltersFromStorage(): Params {
		const storedFilters = localStorage.getItem(this.cmdbListFiltersStorageKey);
		if (!storedFilters) return {};

		try {
			const parsedFilters = JSON.parse(storedFilters);
			return parsedFilters && typeof parsedFilters === 'object' && !Array.isArray(parsedFilters) ? parsedFilters : {};
		} catch {
			return {};
		}
	}

	checkCiInViewPermissions(ci: basicCiInterface): void {
		if (ci.allow_digital_term) {
			this.getDigitalTermLogs(ci.id);
		}
		this.lockViewType = false;

		const hasLogisticOperatorPermission = this.PermissionService.hasPermission('cmdb_digital_term_logistic_operator');
		const shouldLockView = ci.status_related === 'Deleted' || (ci.allow_edit === false && !hasLogisticOperatorPermission);

		if (shouldLockView) {
			if (ci.status_related === 'Deleted' && this.viewType === 'edit') {
				this.NotificationService.setNotificationMessage(this.labels.lbl_nao_possivel_editar_ativos_deletados);
			}
			this.viewType = 'read';
			window.history.replaceState(null, '', window.location.pathname.replace('/edit', '/read'));
			this.lockViewType = true;
		}
	}

	changeCiInView(ci: basicCiInterface): void {
		if (this.selectedCi.id === ci.id) return;

		this.checkCiInViewPermissions(ci);
		this.selectedCi = null;
		this.getCiData(ci.id);
	}

	getCiData(idCi: string): void {
		this.isLoadingCiBasicInformation = true;
		this.CmdbRegisterPageService.getCiData(idCi, this.baselineDate).subscribe({
			next: (ciData) => {
				this.selectedCi = ciData;
				this.selectedCi.relationships = ciData.relationships || { childs: [], parents: [] };
				this.selectedCi.isLeaf = this.selectedCi.relationships.childs.length > 0;
				this.selectedCi.isRoot = this.selectedCi.relationships.parents.length > 0;
				this.CmdbRegisterPageService.editonly = true;
				this.CmdbRegisterPageService.ciType = this.selectedCi.type;
				this.isLoadingCiBasicInformation = false;
			},
		});
	}

	changeTab(tab: CMDBRegisterPageTabView, idCi?: string): void {
		this.tabView = tab;
		const ciId = idCi ?? this.selectedCi?.id;
		if (ciId) window.history.replaceState({}, null, `/cmdb/${ciId}/${this.viewType}/${tab}${window.location.search}`);
	}

	cleanSelectedCi(): void {
		this.selectedCi = {
			id: '',
			type: '',
			identification: '',
			last_audit: undefined,
			active: true,
			location: '',
			id_location: '',
			notes: '',
			status: '',
			monthly_depreciation: undefined,
			ready_to_audit: 0,
			cc_customer: '',
			id_customer: '',
			project: '',
			price: 0,
			invoice_number: '',
			enduser: '',
			id_enduser: '',
			warranty_type: '',
			impact: '',
			id_impact: '',
			next_audit: undefined,
			id_department: '',
			department: '',
			purchase_order: '',
			depreciation_limit: undefined,
			physical_location: '',
			purchase_date: undefined,
			warranty_limit: undefined,
			relationships: { childs: [], parents: [] },
			cost_center: '',
			deactivation_date: '',
			label_type: '',
		};
	}

	setFieldsFromBaseline(e: any) {
		//TODO
	}

	confirmButton(elementReference: HTMLElement): void {
		this.NotificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirmClick');
		setTimeout(() => {
			elementReference.classList.remove('confirmClick');
		}, 5000);
	}

	redirectTo(to: string): void {
		this.Router.navigate([to]);
	}

	returnUrl(): void {
		history.back();
	}

	redirectStep(to: CMDBRegisterPageTabView): void {
		this.tabView = to;
	}

	//Impact map Functions

	mouseDownImpactMap = (e: MouseEvent) => {
		if (e.buttons != 1) return;
		this.impactMapPos.sX = e.clientX;
		this.impactMapPos.sY = e.clientY;
		this.impactMapPos.mouseDown = true;
	};

	confirmMouseMoveImpactMap = () => {
		if (!this.impactMapPos.mouseDown) return;
		this.impactMapPos.mouseMove = true;
	};

	moveImpactMap = (e: MouseEvent) => {
		const dx = e.clientX - this.impactMapPos.sX;
		const dy = e.clientY - this.impactMapPos.sY;

		this.impactMapPos.x = this.impactMapPos.x + dx;
		this.impactMapPos.y = this.impactMapPos.y + dy;

		this.impactMapPos.sX = e.clientX;
		this.impactMapPos.sY = e.clientY;
	};

	mouseUpImpactMap = () => {
		this.impactMapPos.mouseDown = false;
		this.impactMapPos.mouseMove = false;
	};

	onNodeSelect(selectedNode: TreeNode<ciInterface2>): void {
		this.mouseUpImpactMap();
		if (selectedNode.data.id == this.selectedCi.id) return;

		this.CmdbInfoPageService.getCiEditPermission(selectedNode.data.type).subscribe((permissions) => {
			if (!this.PermissionService.hasPermission(permissions.view_permission)) {
				this.NotificationService.setNotificationMessage(this.labels.lbl_cmdb_visualizar_ci_sem_permissao);
				return;
			}

			this.canEditSelectedCi = this.PermissionService.hasPermission(permissions.edit_permission);
			this.selectedNode = selectedNode;
			this.getCiData(selectedNode.data.id);
		});
	}

	expandCiTreeDown(event: Event, selectedCi: TreeNode<ciInterface2>): void {
		this.mouseUpImpactMap();
		if (event) event.stopPropagation();
		if (this.isLoadingImpactMapCiChildrens) return;
		this.isLoadingImpactMapCiChildrens = true;

		const observables = selectedCi.data.relationships.childs.map((ci) =>
			this.CmdbRegisterPageService.getCiData(ci.id_related, this.baselineDate)
		);
		const allObs$ = zip(...observables);
		allObs$
			.subscribe({
				next: (childCisRes) => {
					selectedCi.data.isLeaf = false;
					const existingChild = selectedCi.children;
					for (const childCi of childCisRes) {
						let childAlreadyExist = false;
						for (const existChild of existingChild) {
							if (existChild.data.id.toString() == childCi.id.toString()) childAlreadyExist = true;
						}
						if (childAlreadyExist == false) {
							const newLeaf: TreeNode<ciInterface2> = {
								label: childCi.identification,
								expanded: true,
								data: childCi,
								children: [],
								parent: null,
							};
							childCi.isLeaf = childCi.relationships.childs.length > 0;
							childCi.isRoot = childCi.relationships.parents.length > 0;
							selectedCi.children.push(newLeaf);
						}
					}
					for (const child of selectedCi.children) {
						child.data.isRoot = false;
					}
					const temporaryImpactMapData = JSON.parse(JSON.stringify(this.impactMapData));
					this.selectedNode = selectedCi;
					this.impactMapData = temporaryImpactMapData;
				},
			})
			.add(() => {
				this.isLoadingFirstTreeDownLevel = false;
				this.isLoadingImpactMapCiChildrens = false;
			});
	}

	expandCiTreeUp(event: Event, selectedCi: TreeNode<ciInterface2>): void {
		this.mouseUpImpactMap();
		event.stopPropagation();
		if (this.isLoadingImpactMapCiParents) return;
		this.isLoadingImpactMapCiParents = true;
		this.CmdbRegisterPageService.getCiData(selectedCi.data.relationships.parents[0].id_related, this.baselineDate)
			.subscribe({
				next: (parentCi) => {
					selectedCi.data.isRoot = false;
					const newRoot: TreeNode<ciInterface2> = {
						label: parentCi.identification,
						expanded: true,
						data: parentCi,
						children: [],
						parent: null,
					};
					selectedCi.parent = newRoot;
					parentCi.isLeaf = parentCi.relationships.childs.length > 0;
					parentCi.isRoot = parentCi.relationships.parents.length > 0;
					const temporaryImpactMapData = JSON.parse(JSON.stringify(this.impactMapData));
					newRoot.children = temporaryImpactMapData;
					this.selectedNode = selectedCi;
					this.impactMapData = [newRoot];
				},
			})
			.add(() => {
				this.isLoadingImpactMapCiParents = false;
			});
	}

	zoomInImpactMap(): void {
		if (this.impactMapPos.zoomLevel === 3) return;
		this.impactMapPos.zoomLevel += 0.25;
	}

	zoomOutImpactMap(): void {
		if (this.impactMapPos.zoomLevel === 0.5) return;
		this.impactMapPos.zoomLevel -= 0.25;
	}
	//EO Impact map Functions

	saveCmdbDigitalTerm(): void {
		if (this.isUpdatingDigitalTerm) return;
		// Validação de confirmação quando houver responsável substituto selecionado
		if (
			this.cmdbDigitalTermPayload &&
			this.cmdbDigitalTermPayload.user_substitute &&
			this.cmdbDigitalTermPayload.user_substitute !== '' &&
			!this.isUserNotified
		) {
			let selectedUser: any = null;

			if (this.allowedUserCopy && this.allowedUserCopy.length > 0) {
				selectedUser = this.allowedUserCopy.find((user: any) => user.value === this.cmdbDigitalTermPayload.user_substitute);
			}

			if (selectedUser) {
				const userName = selectedUser.name || selectedUser.full_name || '';
				const userEmail = selectedUser.email || '';

				const message =
					`${this.labels.lbl_geral_substituto_responsavel}: ${userName} (${userEmail}).` +
					`\nDeseja realmente enviar o termo para este responsável substituto?`;

				this.NotificationService.setNotificationMessage(message);
				this.isUserNotified = true;
				return;
			}
		}

		this.isUpdatingDigitalTerm = true;

		this.cmdbDigitalTermPayload.customerUrl = new URL(window.location.href).origin;

		if (this.cmdbDigitalTermPayload?.id) {
			const termId = this.cmdbDigitalTermPayload.id.toString();

			if (this.validateDigitalTermForm()) {
				this.isUpdatingDigitalTerm = false;
				return this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			}

			this.CmdbHomeScreenService.updateCmdbDigitalTerm(termId, this.cmdbDigitalTermPayload)
				.subscribe({
					next: () => {
						this.closeBox();
						this.isEditingTerm = false;
						this.isUserNotified = false;
						this.getDigitalTermLogs(this.selectedCi.id);
						this.NotificationService.setNotificationMessage(this.labels.lbl_termo_digital_enviado_sucesso);
					},
					error: (errorRes) => {
						if (errorRes.error.ExtendedInfo && errorRes.error.ExtendedInfo != '') {
							const extendedInfo = this.labels[errorRes.error.ExtendedInfo]
								? this.labels[errorRes.error.ExtendedInfo]
								: errorRes.error.ExtendedInfo;
							this.NotificationService.setNotificationMessage(extendedInfo);
						}
					},
				})
				.add(() => {
					this.isUpdatingDigitalTerm = false;
				});
		} else {
			this.CmdbHomeScreenService.createCmdbDigitalTerm(this.cmdbDigitalTermPayload)
				.subscribe({
					next: (response) => {
						if (response.status === 201) {
							this.closeBox();
							this.isEditingTerm = false;
							this.isUserNotified = false;
							this.getDigitalTermLogs(this.selectedCi.id);
							this.NotificationService.setNotificationMessage(this.labels.lbl_termo_digital_enviado_sucesso);
						} else if (response.status === 206) {
							this.isEditingTerm = true;
							this.isUserNotified = false;
							this.NotificationService.setNotificationMessage(this.labels.lbl_termo_usuario_nao_associado);
						}
					},
					error: (errorRes) => {
						if (errorRes.error.ExtendedInfo && errorRes.error.ExtendedInfo != '') {
							const extendedInfo = this.labels[errorRes.error.ExtendedInfo]
								? this.labels[errorRes.error.ExtendedInfo]
								: errorRes.error.ExtendedInfo;
							this.NotificationService.setNotificationMessage(extendedInfo);
						}
					},
				})
				.add(() => {
					this.isUpdatingDigitalTerm = false;
				});
		}
	}

	closeBox(): void {
		this.isVisible = false;
		this.isEditingTerm = true;
	}

	toggleEditMode(): void {
		this.isEditingTerm = !this.isEditingTerm;
		this.isEditingTerm ? this.setDigitalTermFieldsDefault() : this.restoreDigitalTermFields();
	}

	getDigitalTermLogs(idCMDB: string): void {
		if (this.ciTermLogReq) this.ciTermLogReq.unsubscribe();

		this.isLoadingLogTerm = true;
		this.ciTermLogReq = this.CmdbInfoPageService.getCmdbDigitalTerm(idCMDB).subscribe((data) => {
			this.cmdbDigitalTermLogPayload = data;
		});
		this.ciTermLogReq.add(() => {
			this.isLoadingLogTerm = false;
		});
	}

	downloadDigitalTerm(fileName: string): void {
		this.CmdbInfoPageService.getTermFile(fileName).subscribe({
			next: (file) => {
				// Criar data URI diretamente do Base64
				const dataUri = `data:${file.mimeType};base64,${file.content}`;
				const link = document.createElement('a');
				link.href = dataUri;
				link.download = file.name;
				document.body.append(link);
				link.click();
				link.remove();
			},
			error: (error) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_rep_custom_arquivo_nao_encontrado);
				console.error('File not found', error);
			},
		});
	}

	loadBaselineToDigitalTerm(idCMDB: string, callback?: () => void): void {
		this.CmdbRegisterPageService.readBaseline(idCMDB).subscribe((data) => {
			this.baselineToDigitalTermPayload = data;
			if (callback) {
				callback();
			}
		});
	}

	setDigitalTermFieldsDefault(): void {
		this.cmdbDigitalTermPayload = {
			...this.cmdbDigitalTermPayload,
			checklist: -1,
			return_or_exchange_equipment: -1,
			user_disconnected: -1,
			third_party_user: -1,
		};
	}

	restoreDigitalTermFields(): void {
		this.cmdbDigitalTermPayload = {
			...this.cmdbDigitalTermPayload,
			checklist: this.cmdbDigitalTermPayloadCopy?.checklist ?? -1,
			return_or_exchange_equipment: this.cmdbDigitalTermPayloadCopy?.return_or_exchange_equipment ?? -1,
			user_disconnected: this.cmdbDigitalTermPayloadCopy?.user_disconnected ?? -1,
			third_party_user: this.cmdbDigitalTermPayloadCopy?.third_party_user ?? -1,
		};
	}

	validateDigitalTermForm(): boolean {
		return (
			this.cmdbDigitalTermPayload.checklist === -1 ||
			this.cmdbDigitalTermPayload.return_or_exchange_equipment === -1 ||
			this.cmdbDigitalTermPayload.user_disconnected === -1 ||
			this.cmdbDigitalTermPayload.third_party_user === -1
		);
	}

	disableDigitalTermEditing(): boolean {
		if (this.viewType === 'edit') return true;

		const allowedStatus = ['Em Estoque', 'Em Uso'];
		const isStatusAllowed = allowedStatus.includes(this.selectedCi.status);

		return !isStatusAllowed;
	}

	async getSendEmailCopy(): Promise<void> {
		this.isLoadingUserCopy = true;
		try {
			const users = await firstValueFrom(this.CmdbRegisterPageService.getSendEmailCopy());
			this.allowedUserCopy = [];
			this.allowedUserCopyIAC = [];
			this.allowedUserCopy = users;
			for (const user of this.allowedUserCopy) {
				const usersIAC: iacOptionInterface = {
					name: user.name,
					secondName: user.email,
					value: user.value,
					commonGroup: user.email,
				};
				this.allowedUserCopyIAC.push(usersIAC);
			}
			this.isLoadingUserCopy = false;
		} catch {
			this.isLoadingUserCopy = false;
		}
	}
}
